import { render } from "./ScoreBoard.html?vue&type=template&id=0e8c8c7e&external"
import script from "./ScoreBoard.js?vue&type=script&lang=js&external"
export * from "./ScoreBoard.js?vue&type=script&lang=js&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__